exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file[data-v-0c74e1ce]{display:inline-block}.file .button[data-v-0c74e1ce]{opacity:0;pointer-events:none}.file:hover button[data-v-0c74e1ce]{opacity:1;pointer-events:all}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/tmp/build_919341db/resources/nuxt/assets","/static":"/tmp/build_919341db/resources/nuxt/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c74e1ce","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/nuxt/pages/office/orders/_id.vue
// module id = s+of
// module chunks = 38